<template lang="pug">
div.basicInform
    Form(:label-width="120",v-disabled="seeState")
        FormItem(label='案例标题')
            Input(placeholder="请填写案例标题",v-model='from.title',v-Mustfillin,:maxlength="25",v-disabled="seeState").case-title
        FormItem(label='案例类型')
            div.tag
                ul
                    Tag(v-for='item in from.type',
                        :key='item',closable,
                        @on-close="handleClose(item)") {{item}}
                    button(type='button',
                        v-if='addTag && from.type.length < 3',
                        @click='fun_addButton').text-button 点击添加
                    Input(v-else,@on-blur='fun_addTag',
                        ref='addInput'
                        v-model.trim='addTagData'
                        :maxlength='4'
                        ).add-tag
            button(type='button',
              v-if="from.type.indexOf('再分配型')<0",
              @click="from.type.push('再分配型')").tag-b 再分配型
            button(type='button',
              v-if="from.type.indexOf('实质性')<0",
              @click="from.type.push('实质性')").tag-b 实质性
            button(type='button',
              v-if="from.type.indexOf('程序性')<0",
              @click="from.type.push('程序性')").tag-b 程序性
        FormItem(label='案例简介',placeholder='出生人口、人口结构、性别比例、出生率、死亡率等')
            textarea.Case-brief(v-model='from.CaseBrief')
        FormItem(label="案例介绍",prop="introduce")
          quill-editor.editor1(v-model='from.introduce',:options = "establishOption",:disabled="seeState" ).zindex6
        FormItem(label="实验资料",prop="stem")
          quill-editor.editor1(v-model='from.stem',:options = "establishOption",:disabled="seeState" ).zindex6
          .span 可录入用于学生在实训过程中查看的相关理论知识。
        FormItem(label='上传案例封面')
            div.upload-Resources
                div.upload-content
                    Upload(action="/",:before-upload="handleUpload",
                        :format="['jpg','jpeg','png']",:max-size="2048",
                        accept="jpeg")
                        img(:src='src',v-if="src!==''").preview
                        img(src='../../../assets/case/Bitmap.png',v-else).upload-icon
                    span(v-if="src===''") 分辨率210*118，不大于2M
        button.up-button(@click='fun_upload("submit")',type="button",v-if="!seeState")  确定
        button(type="button",@click="goback").cancel  取消
</template>

<script>
import { InputNumber } from "ant-design-vue-findsoft";
import * as Quill from "quill"; // 引入编辑器
const fonts = ["SimSun", "SimHei", "Microsoft-YaHei", "KaiTi", "FangSong", "Arial", "sans-serif"];
const Font = Quill.import("formats/font");
Font.whitelist = fonts; // 将字体加入到白名单
Quill.register(Font, true);
export default {
  components: {
    aInputNumber: InputNumber
  },
  directives: {
    Mustfillin: {
      // 指令的定义
      inserted(el) {
        console.log(this);
        el.focus();
      }
    }
  },
  inject: ["seeState"],
  data() {
    return {
      addTag: true,
      addTagData: "",
      from: {
        title: "", // 名称
        CaseBrief: "", // 案例简介
        stem: "", // 资料
        type: [],
        file: "",
        introduce: "" // 案例介绍
      },
      forms: {
        model: "问卷调查",
        questionList: [
          {
            content: ""
          }
        ],
        answer: "",
        // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
        scoringKeywords: [],
        score: 0
      },
      ruleValidate: {
        stem: [{ required: true, message: "问题不能为空", trigger: "blur" }],
        answer: [{ required: true, message: "答案不能为空", trigger: "blur" }]
      },
      // 富文本编辑器配置
      establishOption: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              { font: fonts },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      },
      src: ""
    };
  },
  methods: {
    goback() {
      if (this.$role.role === "student") {
        this.$router.push({
          path: "/Student/custom-case"
        });
      } else {
        this.$router.push({
          path: "/Teacher/case"
        });
      }
    },
    handleUpload(file) {
      const that = this;
      this.from.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      // eslint-disable-next-line
      reader.onloadend = function() {
        that.src = this.result;
      };

      return false;
    },
    handleClose(name) {
      const index = this.from.type.indexOf(name);
      this.from.type.splice(index, 1);
    },
    fun_addButton() {
      this.addTag = !this.addTag;
      this.$nextTick(() => {
        this.$refs.addInput.focus();
      });
    },
    fun_addTag() {
      const that = this;
      function find(value) {
        return value === that.addTagData;
      }
      if (!this.from.type.find(find) && this.addTagData) {
        this.from.type.push(this.addTagData);
        this.addTagData = "";
        this.addTag = !this.addTag;
      }
    },
    /** 2021年3月3日：这两个方法，upload1好像没用到，只在upload处理 */
    fun_upload(type) {
      console.log("这个方法执行了");
      if (this.from.id) {
        // 编辑案例
        const data = new FormData();
        this.$store.commit("getCaseData", this.from.id);
        data.append("caseDescription", this.from.CaseBrief);
        data.append("caseName", this.from.title);
        data.append("caseTypes", JSON.stringify(this.from.type));
        data.append("userId", this.$role.code);
        data.append("id", this.from.id);
        data.append("editorOption", this.from.stem);
        data.append("caseIntroduce", this.from.introduce);
        if (this.$role.role === "student") {
          data.append("classId", sessionStorage.getItem("classId"));
          data.append("isTeacherExp", false);
          data.append("auditStatus", "未提交");
          data.append("teacherExp", false);
        } else {
          data.append("isPublish", false);
          data.append("isTeacherExp", true);
          data.append("teacherExp", true);
        }
        if (this.from.file === "") {
          data.append("caseCover", "");
        } else {
          data.append("caseCover", this.from.src);
          data.append("image", this.from.file);
        }
        this.$http.updateCaseExperiment(data).then(res => {
          if (res.data.success) {
            this.from.src = res.data.data.caseCover;
            this.from.id = res.data.data.id;
            this.from.stem = res.data.data.editorOption;
            this.from.introduce = res.data.data.caseIntroduce;
            this.$store.commit("postCaseContent", this.from);
            this.$store.commit("getDoCaseData", res.data.data.id);
            // this.parent.chengeIndex(1);
            if (type === "submit") this.$Message.success("保存成功");
            // this.$router.push("/case/policy");
          }
        });
      } else {
        // 创建案例
        const data = new FormData();
        data.append("caseDescription", this.from.CaseBrief);
        data.append("caseName", this.from.title);
        data.append("caseTypes", JSON.stringify(this.from.type));
        data.append("userId", this.$role.code);
        data.append("image", this.from.file);
        data.append("editorOption", this.from.stem);
        data.append("caseIntroduce", this.from.introduce);
        if (this.$role.role === "student") {
          data.append("auditStatus", "TO_SUBMIT");
          data.append("classId", sessionStorage.getItem("classId"));
          data.append("isTeacherExp", false);
          data.append("teacherExp", false);
        } else {
          data.append("isPublish", false);
          data.append("isTeacherExp", true);
          data.append("teacherExp", true);
        }
        if (this.src === "") {
          return this.$Message.error("请选择上传资源");
        }
        this.$http.createCaseExperiment(data).then(async res => {
          if (res.data.success) {
            this.from.src = res.data.data.caseCover;
            this.from.id = res.data.data.id;
            this.from.stem = res.data.data.editorOption;
            this.from.introduce = res.data.data.caseIntroduce;
            this.$store.commit("postCaseContent", this.from);
            // this.$store.commit("getCaseData", res.data.data.id);
            const { data: navList } = await this.$http.getCaseHallNavbarList(res.data.data.id);
            this.parent.chengeIndex(1, navList.data.sort((a, b) => a.sortNo - b.sortNo)[0].id);
            this.$router.push("/case/policy");
          }
        });
      }
    },
    fun_upload1() {
      console.log("这个方法没有用到");
      if (this.from.id) {
        // 编辑案例
        const data = new FormData();
        data.append("caseName", this.from.title);
        data.append("caseTypes", JSON.stringify(this.from.type));
        data.append("userId", this.$role.code);
        data.append("caseDescription", this.from.CaseBrief);
        data.append("id", this.from.id);
        data.append("editorOption", this.from.stem);
        if (this.$role.role === "student") {
          data.append("classId", sessionStorage.getItem("classId"));
          data.append("isTeacherExp", false);
          data.append("auditStatus", "未提交");
          data.append("teacherExp", false);
        } else {
          data.append("isPublish", false);
          data.append("isTeacherExp", true);
          data.append("teacherExp", true);
        }
        if (this.from.file === "") {
          data.append("caseCover", "");
        } else {
          data.append("caseCover", this.from.src);
          data.append("image", this.from.file);
        }
        this.$http.updateCaseExperiment(data).then(res => {
          if (res.data.success) {
            this.$Message.success("保存成功");
            this.$store.commit("postCaseContent", this.from);
            if (this.$role.role === "student") {
              this.$router.push("/Student/custom-case");
            } else {
              this.$router.push("/Teacher/case");
            }
          }
        });
      } else {
        // 创建案例
        const data = new FormData();
        data.append("caseDescription", this.from.CaseBrief);
        data.append("caseName", this.from.title);
        data.append("caseTypes", JSON.stringify(this.from.type));
        data.append("userId", this.$role.code);
        data.append("image", this.from.file);
        data.append("editorOption", this.from.stem);
        if (this.$role.role === "student") {
          data.append("auditStatus", "TO_SUBMIT");
          data.append("classId", sessionStorage.getItem("classId"));
          data.append("isTeacherExp", false);
          data.append("teacherExp", false);
        } else {
          data.append("isPublish", false);
          data.append("isTeacherExp", true);
          data.append("teacherExp", true);
        }
        if (this.src === "") {
          return this.$Message.error("请选择上传资源");
        }
        this.$http.createCaseExperiment(data).then(res => {
          if (res.data.success) {
            this.$Message.success("保存成功");
            this.$store.commit("postCaseContent", this.from);
            if (this.$role.role === "student") {
              this.$router.push("/Student/custom-case");
            } else {
              this.$router.push("/Teacher/case");
            }
          }
        });
      }
    },
    /** 根据id获得案例介绍 2021年3月3日 后端字段不好给，从单独的接口获得 */
    async getCaseIntroduce(id) {
      if (id) {
        const {
          data: { data }
        } = await this.$http.getCaseIntroduce({ pyId: id });
        return data;
      }
      return "";
    }
  },
  mounted() {
    console.log(this.$role);
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    parent() {
      return this.$parent;
    }
  },
  created() {
    this.$nextTick(async () => {
      this.from = this.parent.Case.basic;
      this.src = this.from.src;
      await this.getCaseIntroduce(this.from.id).then(introduce => {
        this.from = { ...this.from, introduce };
      });
      if (this.from.id && sessionStorage.getItem("SeeState") === "false") {
        console.log(this.from.id, "这是diddddddddddddd要进行修改");

        this.fun_upload();
      }
    });
  },
  watch: {
    from: {
      handler(newVal) {
        if (newVal) {
          if (this.from.type.length > 3) {
            this.$Message.info("最多只能添加三个标签");
            this.from.type.length = 3;
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="stylus" socped>
.basicInform
  padding-top 72px
  position relative
  width 50%
  text-align center
  margin 0 auto
  overflow scroll
  .ivu-form-item
    margin-bottom 0
    padding-bottom 24px
  .case-title
    height 32px
    width 100%
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
  .case-number
    width 132px
  .tag-b
    height 28px
    width 72px
    background rgba(58, 118, 210, 1)
    border-radius 4px
    border none
    color #ffffff
    outline none
    float left
    margin-left 8px
    margin-top 8px
    cursor pointer
  .tag
    padding 7px
    width 100%
    height 72px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    text-align left
    overflow auto
    .add-tag
      width 120px
      input
        border none
        outline none
      .ivu-input:focus
        box-shadow none
    .ivu-tag
      background #3A76D2
      height 28px
      line-height 28px
      .ivu-tag-text
        color #ffffff
      .ivu-icon-ios-close
        color #ffffff
  .Case-brief
    z-index 6
    position relative
    width 100%
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    resize none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    padding 5px
  .up-button
    width 100px
    height 40px
    background rgba(58, 118, 210, 1)
    border-radius 4px
    cursor pointer
    border none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 18px
    float left
    margin-left 123px
  .cancel
    cursor pointer
    width 100px
    height 40px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    outline none
    float left
    border 1px solid rgba(58, 118, 210, 1)
    margin-left 16px
  .upload-Resources
    width 184px
    height 118px
    background rgba(238, 242, 245, 1)
    border-radius 4px
    border 1px solid rgba(220, 220, 220, 1)
    .upload-content
      width 160px
      height 90px
      background #fff
      text-align center
      margin 0 auto
      vertical-align middle
      margin-top 13px
      position relative
      .preview
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        cursor pointer
        width 160px
        height 90px
      span
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(128, 128, 128, 0.5)
        line-height 15px
        position absolute
        bottom 6px
        white-space nowrap
        left 0
        right 0
      .upload-icon
        height 36px
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        cursor pointer
  .editor1
    background #ffffff
    .ql-toolbar.ql-snow + .ql-container.ql-snow
      height 136px
  .span
    font-size 14px
    font-family AlibabaPuHuiTi-Regular, AlibabaPuHuiTi
    font-weight 400
    color rgba(0, 0, 0, 0.45)
    text-align left
</style>
